export const sidePageTransition = {
  name: 'side-page',
  duration: {
    enter: 1300,
    leave: 1000,
  },
};
